export default __webpack_public_path__ + "static/media/blm-protest-mother-son.d71405ff.png";